<script lang="ts" setup>
  import { usePlanJoinStore } from "~/stores/PlanJoinStore";
  import { useSnackBarStore } from "~/stores/SnackBarStore";

  const planJoinStore = usePlanJoinStore();
  const snackBarStore = useSnackBarStore();

  interface Props {
    planId: string;
    width?: number;
  }
  const props = withDefaults(defineProps<Props>(), {
    width: 280,
  });

  const isConfirmDialogOpen = ref(false);

  const handleContractCancel = async () => {
    try {
      await planJoinStore.contractMemberCancelRequest(props.planId);
      snackBarStore.set("解約をキャンセルしました");
      window.location.reload();
    } catch (error: any) {
      snackBarStore.set("解約のキャンセルに失敗しました");
      sentryErrorLog("解約キャンセル失敗:" + error.message);
    }
  };
</script>
<template>
  <AtomsButton :width="width" color="main-04" class="mx-auto" @click="isConfirmDialogOpen = true">
    解約をキャンセルする
  </AtomsButton>
  <MoleculesYesNoDialog
    v-model:is-open="isConfirmDialogOpen"
    message="解約をキャンセルします。よろしいですか？"
    @click-yes="handleContractCancel"
    @click-no="isConfirmDialogOpen = false"
  />
</template>
